import { render, staticRenderFns } from "./IconSvgVideoLink.vue?vue&type=template&id=08ffb7c8&scoped=true&"
import script from "./IconSvgVideoLink.vue?vue&type=script&lang=js&"
export * from "./IconSvgVideoLink.vue?vue&type=script&lang=js&"
import style0 from "./IconSvgVideoLink.vue?vue&type=style&index=0&id=08ffb7c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ffb7c8",
  null
  
)

export default component.exports